<template>
  <div>
    <!-- <div
      v-if="userInfo && userInfo.user"
      class="sticky top-0 z-50 bg-white shadow-md"
    >
      <StudentHeader v-if="this.userInfo.user.permission == 'student'" />
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div> -->
    <div class="w-full">
      <div
        class="container mx-auto max-w-[1200px]"
        style="min-height: 70vh !important"
      >
        <div class="py-10 px-6" v-if="notificationIndex == null">
          <div class="font-bold text-xl pb-3 flex items-center gap-2">
            Messages
            <p
              class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
              v-if="total_count != 0"
            >
              {{ total_count }}
            </p>
          </div>
          <div class="flex flex-col gap-3 p-4 bg-gray-50/50 rounded-3xl">
            <!-- Loading State -->

            <div
              v-if="loading"
              class="flex flex-col items-center justify-center h-[calc(95vh-100px)]"
            >
              <div
                class="animate-spin rounded-full h-10 w-10 border-b-2 border-[#01b0f9]"
              ></div>
            </div>
            <div v-else-if="messageList.length > 0">
              <div class="flex flex-col gap-3">
                <div v-for="(message, index) in messageList" :key="index">
                  <div
                    class="group relative flex justify-between border transition-all duration-300 gap-4 py-4 px-6 rounded-2xl cursor-pointer"
                    :class="{
                      'bg-white border-blue-500 shadow-md ring-1 ring-blue-100 hover:bg-blue-50':
                        !message.readed,
                      'bg-white border-gray-300 hover:bg-gray-100 hover:border-gray-300':
                        message.readed,
                    }"
                    @click="handleMessageClick(message)"
                  >
                    <div
                      v-if="!message.readed"
                      class="absolute left-0 top-1/4 bottom-1/4 w-1 bg-blue-500 rounded-r-full"
                    ></div>

                    <div class="flex items-start gap-5 w-full">
                      <div class="flex-shrink-0 mt-1">
                        <div
                          class="p-2 rounded-full transition-colors"
                          :class="
                            !message.readed ? 'bg-blue-50' : 'bg-gray-100'
                          "
                        >
                          <img
                            v-if="message.readed"
                            src="@/assets/newd/Vector(2).svg"
                            class="w-4 h-4 grayscale opacity-50"
                            alt="read"
                          />
                          <img
                            v-else
                            src="@/assets/newd/Group(1).svg"
                            class="w-4 h-4"
                            alt="unread"
                          />
                        </div>
                      </div>

                      <div class="flex flex-col gap-1 w-full overflow-hidden">
                        <div class="flex items-center gap-2">
                          <h4
                            class="text-xs truncate transition-colors uppercase font-bold"
                            :class="
                              !message.readed
                                ? 'font-bold text-slate-900'
                                : 'font-medium text-slate-600'
                            "
                          >
                            {{ message.owner_display_name || "NA" }}
                          </h4>
                          <span
                            v-if="!message.readed"
                            class="flex-shrink-0 bg-blues text-[10px] text-white px-2 py-0.5 rounded-full font-bold uppercase tracking-wider"
                            >New</span
                          >
                        </div>

                        <div class="flex flex-col">
                          <p class="text-[12px] tracking-tight text-slate-400">
                            {{ message.course_title || "NA" }}
                            <span class="mx-1 text-gray-300">-</span> Sem
                            {{ message.semester || "NA" }}
                          </p>
                          <p
                            class="text-xs line-clamp-1 mt-1"
                            :class="
                              !message.readed
                                ? 'text-slate-700 font-medium'
                                : 'text-slate-500 font-normal'
                            "
                          >
                            {{ message.text || "No preview available..." }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex flex-col justify-start items-end min-w-fit pt-1"
                    >
                      <span
                        class="text-[11px] font-semibold whitespace-nowrap"
                        :class="
                          !message.readed ? 'text-blue-600' : 'text-slate-400'
                        "
                      >
                        {{ formatDateTime(message.created_at) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="messageList.length > 0"
                class="flex justify-center py-4 space-x-2"
              >
                <!-- <Pagination  /> -->

                <Pagination
                  :totalPages="totalPages"
                  @page-changed="loadMessages"
                />
              </div>
            </div>

            <div
              v-else
              class="flex flex-col items-center justify-center py-16 px-6 border-2 border-dashed border-gray-200 rounded-3xl text-center"
            >
              <p class="text-slate-500 text-sm max-w-[200px]">
                No Messages Found
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// import AdminHeader from "@/components/Admin/Header.vue";
// import HodHeader from "@/components/Hod/Header.vue";
// import CoordinateHeader from "@/components/Coordinate/Header.vue";
// import InstructorHeader from "@/components/Instructor/Header.vue";

import Footer from "@/components/Footer.vue";
import StudentHeader from "@/components/Student/Header.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Notifications",

  components: {
    // StudentHeader,
    Footer,
    // AdminHeader,
    // HodHeader,
    // CoordinateHeader,
    // InstructorHeader,
    Pagination,
  },

  data() {
    return {
      messageList: [],
      notificationIndex: null,
      selectNotificationData: "",
      notifyprocess: [],
      currentPage: 1,
      totalPages: 1,
      total_count: 0,
      loading: false,
    };
  },

  computed: {
    ...mapGetters("student", ["studentdata"]),
  },

  created() {
    this.getMessages(1);
  },

  mounted() {},

  methods: {
    formatDateTime(dateString) {
      const date = new Date(dateString);
      const now = new Date();

      const isSameDate =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

      if (isSameDate) {
        // Show only time if today
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      } else {
        // Show full date and time if not today
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      }
    },

    async getMessages(page) {
      try {
        await axios
          .get(
            `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${this.studentdata.studentId}&Key=${this.studentdata.studentToken}&page=${page}`,
          )
          .then((response) => {
            if (response) {
              this.totalPages = response.data.data.total_page;
              this.messageList = response.data.data.data;
              this.total_count = response.data.data.total;
            }
          });
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        this.loading = false;
      }
    },
    handleMessageClick(message) {
      console.log("dsfsdsdf", message.id);
      console.log("dsfsdsdf", message.client_department_id);

      let formdata = {
        readed: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/message-read-update/${message.id}/?Key=${this.studentdata.studentToken}`,
          formdata,
        )
        .then((response) => {
          if (response.data.status === 200) {
            if (message.course_id || message.client_department_id) {
              
                this.$router.push(
                  `/student/dashboard/${message.course_id}/newmessages`,
                );
                localStorage.setItem(
                  "pendingChatUser",
                  JSON.stringify({
                    userId: message.owner,
                    userName: message.owner_display_name,
                    roomId: message.room,
                  }),
                );
                console.log("123456", message);
            } else {
              console.warn("No course_id in message. Navigation skipped.");
            }
          }
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr {
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
